const SVGComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M9.00864 13.9898C8.9186 13.8834 9.56255 12.8442 9.56255 12.6878C9.56255 12.5314 9.60757 12.4 9.69762 12.2936L13.1935 8.16436C13.2835 8.05174 13.3947 7.997 13.5272 8.00013C13.6596 8.00326 13.7708 8.058 13.8609 8.16436C13.9509 8.27072 13.9972 8.4021 13.9999 8.55851C14.0025 8.71492 13.9562 8.84631 13.8609 8.95267L10.365 13.0819C10.275 13.1883 10.1637 13.243 10.0313 13.2461C9.89889 13.2493 9.09868 14.1024 9.00864 13.9898Z"
      fill="white"
    />
    <path
      d="M8.25684 2.32031C8.78566 2.32048 9.21387 2.74946 9.21387 3.27832C9.21384 3.80716 8.78565 4.23616 8.25684 4.23633C7.72788 4.23633 7.29885 3.80727 7.29883 3.27832C7.29883 2.74935 7.72787 2.32031 8.25684 2.32031ZM8.24121 2.79199C7.98106 2.79199 7.76953 3.00255 7.76953 3.2627C7.7696 3.52278 7.98111 3.7334 8.24121 3.7334C8.50113 3.73319 8.71184 3.52265 8.71191 3.2627C8.71191 3.00268 8.50118 2.7922 8.24121 2.79199Z"
      fill="white"
    />
    <path
      d="M2 9L5.916 5L8.028 7.45161M8.028 7.45161L10.052 5.15484L13 7.83871M8.028 7.45161L9.01974 8.46429"
      stroke="white"
      strokeWidth={0.5}
    />
    <path
      d="M14 6H13V0.933594H0.933594V13.0664H8.40039V14H0V0H14V6Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
